import React from 'react';
import Store from './store';

function initializeStores() {
    return {
        store: new Store(),
    };
}

const stores = initializeStores();
const StoreContext = React.createContext<typeof stores>(null as any);
export const StoreProvider = ({
    children,
    mobxStores,
}: {
    children: any;
    mobxStores: typeof stores;
}) => {
    return (
        <StoreContext.Provider value={{ ...mobxStores }}>
            {' '}
            {children}{' '}
        </StoreContext.Provider>
    );
};
export const useStores = () => React.useContext(StoreContext);
export const withStore = (Component: any) => (props: any) => {
    return <Component {...props} store={useStores()} />;
};
export default stores;
